export default "__VITE_ASSET__Caioneuo__"